import { useEffect, useState } from "react"
import { useSearchParams } from "react-router";
import { getPay } from "../../Fetch/GetComp";
import ObjectPDF from "../../Components/PDF/ObjectPDF";
import Loading from "../../Components/Loading/Loading";
import './desglose.css'
export default function PayView() {

 const [Comp, setComp] = useState({
    pdf:[]
  })
  const [searchParams] = useSearchParams();

   useEffect(() => {
      document.title = 'Transferencia';
      getPay(searchParams.get("pay"),searchParams.get("hash")).then(res => {
         setComp(v => ({
          ...v,
          pdf: res.data.payload.map((Fact) => (
            {
              ...v.pdf,
              data:'data:application/pdf;base64,' + Fact.Archivo,
              Ext:Fact.ext,
              idPago:Fact.idMovimiento_Bancario,
              width: '100%',
              height: "800px"
            }
          ))
        }))
      })
    }, [searchParams])

  return (
   <div className="Factview">
         {
           Comp.pdf.length > 0 ?
             Comp.pdf.map((el, ind) => (
              <ObjectPDF  data={el.data}>ObjetoPDF</ObjectPDF>
             ))
             :
             <Loading/>
         }
       </div>
  )
}